import React from 'react';
import { useNestedNavigation } from '../../../../../../utils/appNavigationNames';
import { useProfileSubscribeBanner } from '../../../../../../hooks/useProfileSubscribeBanner';
import Stack from '../../../../../v2BaseComponents/Stack';
import { colors } from '../../../../../../utils/theme';
import Text from '../../../../../v2BaseComponents/Text';
import Button from '../../../../../v2BaseComponents/Button';
import IconButton from '../../../../../v2BaseComponents/IconButton';

export type ProfileSubscribeBannerOwnProps = {
    profileId: string;
};

export type ProfileSubscribeBannerProps = ProfileSubscribeBannerOwnProps;

const ProfileSubscribeBanner: React.FC<ProfileSubscribeBannerProps> = ({ profileId }) => {
    const { nestedAccountNavigation } = useNestedNavigation();
    const { shouldShow, messaging, canDismiss, onDismiss } = useProfileSubscribeBanner({ profileId });

    if (!shouldShow) return null;

    return (
        <Stack
            vertical
            align="flex-start"
            fullWidth
            padding={8}
            style={{ backgroundColor: colors['White'], borderRadius: 8, paddingBottom: 0 }}
            testID="profile-subscribe-banner"
        >
            <Stack horizontal fullWidth justify="space-between" align="center">
                <Text variant="bold-body-1">{messaging.message}</Text>
                {canDismiss ? (
                    <IconButton
                        icon="X"
                        variant="minimal"
                        onPress={onDismiss}
                        testID="profile-subscribe-banner-dismiss-button"
                    />
                ) : null}
            </Stack>
            <Button
                variant="text"
                title={messaging.buttonText}
                onPress={() => nestedAccountNavigation('subscription', undefined)}
                icon="ChevronRight"
                testID="profile-subscribe-banner-subscribe-button"
            />
        </Stack>
    );
};

export default React.memo(ProfileSubscribeBanner);
